<div class="org-index-comp wrapper">
  <ng-container *ngIf="organisation$ | async as organisation; else loading">
    <div class="content">
      <div class="cards">
        <div class="card">
          <div class="card-title-row">
            <div class="card-title">
              Projects
              <span
                style="margin-left: 2px"
                *ngIf="(projects$ | async).length > 4"
              >
                ({{ (projects$ | async)?.length || 0 }})
              </span>
            </div>
            <span>
              <button class="add-btn" (click)="onAddProject()">Add</button>
            </span>
          </div>
          <div class="list">
            <div
              *ngFor="let p of projects$ | async as projects"
              (click)="onProjectClick(p.id)"
            >
              <div class="list-item">
                <div class="list-item-content">
                  <div class="avatar small">{{ (p.name || '?')[0] }}</div>
                  <div class="name">{{ p.name }}</div>
                </div>
                <div
                  *ngIf="!deleteProjectStates[p.id]?.error"
                  class="remove-icon"
                  matTooltip="Delete project"
                >
                  <nw-icon
                    type="close"
                    [size]="14"
                    (click)="deleteProject(p.id); $event.stopPropagation()"
                  ></nw-icon>
                </div>
                <div
                  *ngIf="deleteProjectStates[p.id]?.error"
                  style="margin-right: 4px"
                >
                  <nw-loader
                    *ngIf="deleteProjectStates[p.id]?.loading"
                  ></nw-loader>
                </div>
              </div>
            </div>
            <div
              *ngIf="!(projects$ | async)?.length"
              class="empty"
              style="padding: 16px; font-style: italic"
            >
              No projects
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-title-row">
            <div class="card-title">Team</div>
            <button class="add-btn" (click)="onAddUser()">Add</button>
          </div>
          <div class="list">
            <div *ngFor="let u of users$ | async as users" class="list-item">
              <div class="flex-row gap-8">
                <div class="avatar small">
                  {{ (u.firstName || getUserName(u))[0]
                  }}{{ (u.lastName || '')[0] }}
                </div>
                <span class="name" style="margin-left: 8px">{{
                  getUserName(u)
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Style card -->
        <div class="card" style="overflow: visible">
          <div class="card-title-row">
            <div class="card-title">Style</div>
          </div>
          <div class="style-content">
            <!-- Font Family -->
            <div class="style-row">
              <div class="style-label">Font Family</div>
              <nw-font-family-selector
                [fontFamily]="organisation.fontFamily || ''"
                [emitOnly]="true"
                (fontSelected)="onFontFamilyChange($event)"
              ></nw-font-family-selector>
            </div>
            <!-- Color Palette -->
            <div class="style-row">
              <div class="style-label">Color Palette</div>
              <div
                class="color-palette-preview"
                *ngIf="organisation.colorPalette as palette"
              >
                <div
                  class="color-circle"
                  *ngFor="let entry of palette | keyvalue"
                  [style.background-color]="entry.value"
                  [title]="entry.key + ': ' + entry.value"
                ></div>
                <button
                  class="edit-colors-btn"
                  (click)="openColorPaletteModal()"
                >
                  Edit
                </button>
              </div>
              <div
                class="color-palette-preview"
                *ngIf="!organisation.colorPalette"
              >
                <span class="empty">No colors</span>
                <button
                  class="edit-colors-btn"
                  (click)="openColorPaletteModal()"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="w-100 h-100 flex-row space-around" style="align-items: center">
      <nw-loader *ngIf="isIndexLoading$ | async" [size]="48"></nw-loader>
    </div>
  </ng-template>

  <!-- Color palette modal -->
  <div
    class="modal-overlay"
    *ngIf="showColorPaletteModal"
    (click)="closeColorPaletteModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Edit Color Palette</h3>
        <button class="close-btn" (click)="closeColorPaletteModal()">×</button>
      </div>
      <div class="modal-body">
        <div
          class="color-editor"
          *ngFor="let item of editingPaletteEntries; let i = index"
        >
          <input
            type="text"
            [(ngModel)]="editingPaletteEntries[i].key"
            placeholder="Color name"
          />
          <input type="color" [(ngModel)]="editingPaletteEntries[i].value" />
          <div class="remove-btn">
            <nw-icon
              type="close"
              [size]="12"
              (click)="removeColor(i)"
            ></nw-icon>
          </div>
        </div>
        <button class="add-color-btn" (click)="addColor()">Add Color</button>
      </div>
      <div class="modal-footer">
        <button class="secondary" (click)="closeColorPaletteModal()">
          Cancel
        </button>
        <button class="primary" (click)="saveColorPalette()">Save</button>
      </div>
    </div>
  </div>
</div>
